import _ from 'underscore';

// please in uppercase characters
// please sort alphabetically
const errorCodes = [
  'AUTHORIZATIONEXPIRE',
  'BINGPREVIEWAPIERROR',
  'CAMPAIGNINLINEEDITORIALERROR',
  'CCMTERRORNUMBER_POSTPAYACCOUNTCANTASSOCIATEWITHPREPAIDCARD',
  'DUPLICATEENTITY',
  'ENTITYDOESNOTEXIST',
  'EXCEEDACCOUNTGOALLIMIT',
  'EXCEEDTHELIMIT',
  'ExpandedTextAdInlineEditorialError',
  'FACEBOOKAPIUSERERROR',
  'GOALHAVEDUPLICATENAME',
  'GOALHAVEDUPLICATEURLANDOPERATOR',
  'INSUFFICIENTPERMISSIONORNEEDENABLE2FA',
  'INVALIDACTION',
  'INVALIDACTIONONSMARTPAGEASSOCIATEDMCACAMPAIGN',
  'INVALIDBUSINESSNAME',
  'INVALIDDESTINATIONGOALOPERATOR',
  'INVALIDKEYWORDTEXT',
  'INVALIDPARAMETER',
  'INVALIDVALUE',
  'INVALIDZIPCODE',
  'KEYWORDINLINEEDITORIALERROR',
  'LINKEDINAPIERROR',
  'LOCATIONNOTEXIST',
  'LOCATIONNOTSUPPORTED',
  'MEDIASIZEEXCEEDLIMIT',
  'NEEDADMINPERMISSION',
  'NEEDBUSINESSADMINPERMISSION',
  'PAYMENTNOTSET',
  'PROFILEALREADYLINKED',
  'SMARTPAGEINVALIDSUBDOMAIN',
  'SMARTPAGESUBDOMAINISNOTAVAILABLE',
  'TIMEZONENOTMATCH',
  'TOKENEXPIRED',
  'TOKENNOTMATCHTOPROFILE',
  'TWITTERAPIERROR',
  'TWITTERAPIUSERERROR',
  'UNSUPPORTEDWEBSITEDOMAIN',
  'URLNOTACCESSIBLE',
];

export const expectedErrorCodes = _.chain(errorCodes)
  .map(errorCode => errorCode.trim().toUpperCase())
  .value();

export function isExpectedErrorCodes(errorResponseJson) {
  if (_.isEmpty(errorResponseJson)) {
    return false;
  }
  const errorCodesInResponse = _.chain(errorResponseJson)
    .pluck('Code')
    .compact()
    .map(code => code.trim().toUpperCase())
    .uniq()
    .value();

  if (_.isEmpty(errorCodesInResponse)) {
    return false;
  }

  for (let index = 0; index < errorCodesInResponse.length; index += 1) {
    if (!_.contains(expectedErrorCodes, errorCodesInResponse[index])) {
      return false;
    }
  }
  return true;
}
